module.exports = __webpack_public_path__ + "img/new7.ea0108f5.png";